module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_5012.c1e0a0d9.png";